module.exports = __webpack_public_path__ + "static/media/ghost.ec5fda6d.png";